(() => {
  'use strict';

  const root = document.documentElement;
  let header;
  let resizeObserver;

  const getHeader = () => {
    header = header || document.querySelector('.hdr_wrap');
    return header;
  };

  const updateOffset = () => {
    const currentHeader = getHeader();
    if (!currentHeader) return;

    const gap = window.matchMedia('(max-width: 1024px)').matches ? 14 : 20;
    const height = Math.ceil(currentHeader.getBoundingClientRect().height);

    if (height > 0) {
      root.style.setProperty('--feohwynn-anchor-offset', `${height + gap}px`);
    }
  };

  const getHashTarget = () => {
    if (!window.location.hash || window.location.hash === '#') return null;

    let id = window.location.hash.slice(1);
    try {
      id = decodeURIComponent(id);
    } catch (error) {
      // Keep the literal hash for malformed legacy links.
    }

    const target = document.getElementById(id);
    return target && target.closest('#MainContent') ? target : null;
  };

  const correctHashPosition = () => {
    updateOffset();

    const target = getHashTarget();
    if (!target) return;

    window.requestAnimationFrame(() => {
      const offset = Number.parseFloat(
        window.getComputedStyle(root).getPropertyValue('--feohwynn-anchor-offset')
      ) || 0;
      const targetTop = target.getBoundingClientRect().top + window.scrollY - offset;

      window.scrollTo(0, Math.max(0, targetTop));
    });
  };

  const init = () => {
    updateOffset();

    const currentHeader = getHeader();
    if (currentHeader && 'ResizeObserver' in window) {
      resizeObserver = new ResizeObserver(correctHashPosition);
      resizeObserver.observe(currentHeader);
    }

    correctHashPosition();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }

  window.addEventListener('load', correctHashPosition, { once: true });
  window.addEventListener('hashchange', correctHashPosition);
  window.addEventListener('resize', updateOffset, { passive: true });
  document.addEventListener('shopify:section:load', correctHashPosition);
})();
